import { inject, Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { Meter, MeterAdapter } from "../models/meter.model";
import { HydraoApiService } from "./core/hydrao-api.service";

export class MeterPage {
  constructor(public data: Meter[], public totalCount: number) {}
}

@Injectable({
  providedIn: "root",
})
export class MeterService extends HydraoApiService<Meter> {
  private _meterAdpater: MeterAdapter = inject(MeterAdapter);

  public getMetersForStore() {
    let url;
    const fields =
      "device_uuid,last_seen,first_seen,label,serial,last_update,place_id,features,type,type_request,charge_level,protocol_version,parent_id,children,gateway_uuid";

    url = "/meters?fields=" + fields;

    return this.get(url, this._meterAdpater, true, true);
  }

  public addMeterForStore(
    serial: string,
    label: string,
    parentId?: string,
    placeId?: number
  ): Observable<Meter> {
    let url = "/meters/" + serial + "/register";
    if (placeId) {
      url = "/places/" + placeId + "/register-meter/" + serial;
    }

    const data: any = { label: label };
    if (typeof parentId === "string" && parentId.trim().length > 0) {
      data.parentId = parentId;
    }

    return this.put(url, data, null, false);
  }

  public updateMeterForStore(
    meterUuid: string,
    label: string,
    parentId?: string,
    moveChildren?: boolean,
    placeId?: number
  ): Observable<Meter> {
    let url = "/meters/" + meterUuid;
    const data: any = {
      label: label,
      parent_id: parentId,
      move_children: moveChildren,
      place_id: placeId,
    };

    return this.put(url, data, null, false);
  }

  public removeMeterForStore(meterUuid): Observable<Meter> {
    let url = "/meters/" + meterUuid + "/unregister";
    return this.put(url, null, null, false);
  }
}
